import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  getAppleWalletPassConfig,
  upsertAppleWalletPassConfig,
} from '../../../gateways/breadstack/loyaltyApis'
import type { AppleWalletPassConfigInput } from '../../../types/loyalty'

export const appleWalletPassConfigQueryKey = (storeId: string) =>
  ['loyalty', 'apple-wallet-pass-config', storeId] as const

export const useAppleWalletPassConfigQuery = (storeId: string) =>
  useQuery({
    queryKey: appleWalletPassConfigQueryKey(storeId),
    queryFn: () => getAppleWalletPassConfig(storeId),
    enabled: Boolean(storeId),
  })

export const useUpsertAppleWalletPassConfig = (storeId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (body: AppleWalletPassConfigInput) =>
      upsertAppleWalletPassConfig(storeId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: appleWalletPassConfigQueryKey(storeId),
      })
    },
  })
}
